import { useMemo } from 'react';

import { useQuery } from '@apollo/client';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { Link, useParams } from 'react-router-dom';

import MainBox from '../../../../components/containers/MainBox';
import Error from '../../../../components/Error';
import PageTitle from '../../../../components/layout/PageTitle';
import SkeletonListData from '../../../../components/skeletons/ListData';
import PAPER_BOX_PROPS from '../../../../components/table/styles';
import Table from '../../../../components/table/Table';
import { GET_TRANSFER } from '../../../../gql/catalogs';
import {
  TRANSFER_STATUS_LABEL_MAPPING,
  TRANSFER_STATUS_COLOR_MAPPING,
} from '../../../../lib/transferStatuses';
import CorrectionSummary from '../../components/CatalogShowSummary';
import tableColumns from './components/columns';

const MIN_PAGE_SIZE = 1;

function Transfer() {
  const { id } = useParams();
  const { data, loading, error } = useQuery(GET_TRANSFER, {
    variables: { id },
  });

  const transfer = useMemo(() => {
    const {
      reference,
      seller,
      originWarehouse,
      destinationWarehouse,
      items = [],
      comment,
      createdAt,
      status,
      createdBy,
    } = data?.transfer || {};
    return {
      reference,
      seller,
      originWarehouse,
      destinationWarehouse,
      items,
      createdAt,
      comment,
      status,
      createdBy,
    };
  }, [data]);

  const columns = useMemo(tableColumns, []);
  if (error) {
    return (
      <MainBox>
        <Error />
      </MainBox>
    );
  }
  if (loading)
    return (
      <>
        <PageTitle>Transferencia de inventario</PageTitle>
        <SkeletonListData />
      </>
    );
  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ display: 'flex', gap: 1 }}>
        <PageTitle width="auto">
          Transferencia de inventario {transfer.reference}
          <Chip
            label={
              <Typography sx={{ fontWeight: 500 }}>
                {TRANSFER_STATUS_LABEL_MAPPING[transfer.status]}
              </Typography>
            }
            color={TRANSFER_STATUS_COLOR_MAPPING[transfer.status]}
            variant="outlined"
            sx={{ marginLeft: 3 }}
          />
          <IconButton component={Link} to="pdf">
            <PictureAsPdfOutlinedIcon />
          </IconButton>
        </PageTitle>
      </Box>
      <CorrectionSummary catalogInstance={transfer} />
      <Table
        data={transfer.items}
        columns={columns}
        pagination={{
          customPageSize: transfer.items.length || MIN_PAGE_SIZE,
        }}
        hasStickyHeader={false}
        hasSearchBox={false}
        paperBoxProps={PAPER_BOX_PROPS}
        loading={loading}
        error={error}
      />
    </Box>
  );
}
export default Transfer;
